import Navbar from '../../components/Navbar/Navbar';
import './LandingPage.css';

const FEATURES = [
  {
    id: 'editor',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z" />
      </svg>
    ),
    title: 'Score Editor',
    description:
      'Click on the staff to place notes. Choose durations, add rests, dynamics, and expression markings — all in the browser, no software to install.',
  },
  {
    id: 'midi',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <rect x="5" y="4" width="2" height="9" rx="1" fill="var(--color-card)" />
        <rect x="9" y="4" width="2" height="9" rx="1" fill="var(--color-card)" />
        <rect x="13" y="4" width="2" height="9" rx="1" fill="var(--color-card)" />
        <rect x="17" y="4" width="2" height="9" rx="1" fill="var(--color-card)" />
      </svg>
    ),
    title: 'MIDI Input',
    description:
      'Connect your piano or any MIDI instrument via USB. Play notes directly into your score with step input or real-time recording.',
  },
  {
    id: 'playback',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="12" cy="12" r="10" opacity="0.15" />
        <path d="M10 8.5v7l6-3.5-6-3.5z" />
      </svg>
    ),
    title: 'Score Playback',
    description:
      'Hear your composition with synthesized instrument voices. Control tempo, toggle the metronome, and watch the playhead move through your score.',
  },
];

function LandingPage() {
  return (
    <div className="landing">
      <Navbar />

      <section className="hero">
        <div className="hero__deco" aria-hidden="true">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="hero__deco-line" />
          ))}
          <span className="hero__deco-note hero__deco-note--a">&#9833;</span>
          <span className="hero__deco-note hero__deco-note--b">&#9834;</span>
          <span className="hero__deco-note hero__deco-note--c">&#9835;</span>
        </div>

        <div className="hero__content">
          <span className="hero__eyebrow">For Musicians</span>
          <h1 className="hero__title">
            Compose.<br />Connect.<br />Play.
          </h1>
          <p className="hero__subtitle">
            PlutoCadence is an online workspace for musicians. Write scores,
            connect your MIDI instruments, and hear your music come to life —
            all inside your browser.
          </p>
          <div className="hero__actions">
            <button className="btn btn--primary">Start Composing</button>
            <a className="btn btn--secondary" href="#features">See Features</a>
          </div>
        </div>
      </section>

      <section id="features" className="features">
        <div className="features__inner">
          <h2 className="features__heading">Everything you need to create music</h2>
          <p className="features__subheading">
            From first note to finished score, PlutoCadence has the tools you need.
          </p>
          <div className="features__grid">
            {FEATURES.map((f) => (
              <div key={f.id} className="feature-card">
                <div className="feature-card__icon">{f.icon}</div>
                <h3 className="feature-card__title">{f.title}</h3>
                <p className="feature-card__desc">{f.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="about__inner">
          <h2 className="about__heading">Built for the way musicians think</h2>
          <p className="about__body">
            Most notation software was designed for desktops. PlutoCadence is
            built for the web — fast, accessible, and always up to date. Whether
            you are composing an original piece, transcribing something you heard,
            or practising with your instrument, PlutoCadence fits your workflow.
          </p>
          <button className="btn btn--primary">Get Early Access</button>
        </div>
      </section>

      <footer className="footer">
        <div className="footer__inner">
          <span className="footer__brand">PlutoCadence</span>
          <span className="footer__copy">Built for musicians.</span>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
